import { Box, SxProps } from '@mui/material';
import { stringToDate } from 'src/utils/date-utils';
import { useAuth } from 'src/hooks/useAuth';
import Typography from '@mui/material/Typography'

type Props = {
    value: string,
    label: string,
    format: 'datetime' | 'date' | 'time',
    sx?: SxProps
}

const DateTimeDisplayWithLabel = ({ value, label, format, sx }: Props) => {
    const { user } = useAuth();
    const date = stringToDate(value);

    const culture = user?.culture ?? 'en-US';
    const timezone = user?.timezone ?? "America/New_York"

    const renderDate = () => {
        const options = {
            timeZone: timezone,
            hour12: false
        };

        if(date == null) return "Not Set"

        if (format === 'date') return date?.toLocaleDateString(culture, options)
        if (format === 'time') return date?.toLocaleTimeString(culture, options)

        return date?.toLocaleString(culture, options)
    }

    return <Box sx={{ ...sx }}>{label} {renderDate()}
        
    </Box>
}

export { DateTimeDisplayWithLabel }
export default DateTimeDisplayWithLabel